import React from 'react'

import Link from 'next/link'
import { FormattedMessage } from 'react-intl'
import { Info } from 'components/icons/Info'
import css from './InfoBanner.module.css'

export const InfoBanner = () => {
    return (
        <div className={css.InfoBanner}>
            <Info />
            <div>
                <FormattedMessage
                    defaultMessage="You are viewing <b>archived forecasts</b>. To view the live forecast, <a>click here</a>."
                    values={{
                        b: (...chunks) => <strong>{chunks}</strong>,
                        a: (...chunks) => (
                            <Link href="/">
                                <a>{chunks}</a>
                            </Link>
                        ),
                    }}
                    description="Forecast archive warning modal"
                />
            </div>
        </div>
    )
}
